import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import styled from '@mui/material/styles/styled';
import red from '@mui/material/colors/red';

const ColoredButtonBase = styled(Button)(({ theme }) => ({
  backgroundColor: red[500],
  color: theme.palette.getContrastText(red[700]),
  '&:hover': {
    backgroundColor: red[700],
  },
  '&:disabled': {
    backgroundColor: red[300],
    color: theme.palette.getContrastText(red[700]),
  },
}));

const ColoredCircularProgress = styled(CircularProgress)(({ theme }) => ({
  color: theme.palette.getContrastText(red[700]),
}));

const ColoredButton = ({ children, ...props }) => {
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(props.loading);
  }, [props.loading]);

  return (
    <ColoredButtonBase
      {...props}
      endIcon={loading && <ColoredCircularProgress size={20} />}
    >
      {children}
    </ColoredButtonBase>
  );
};

export { ColoredButton };
